import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.css';

const BenefitArticle = ({ title, image, isLeft, children, className }) => {
  const customClassName = classNames('benefit-article', className, {
    '-left': isLeft,
  });
  return (
    <article className={customClassName}>
      <img className="benefit-illustration" src={image} alt={title} />
      <div>
        <h3>{title}</h3>
        {children}
      </div>
    </article>
  );
};

BenefitArticle.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  image: PropTypes.string.isRequired,
  isLeft: PropTypes.bool,
  className: PropTypes.string,
};

BenefitArticle.defaultProps = {
  children: undefined,
  className: undefined,
  isLeft: false,
};

export default BenefitArticle;
